'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function EventEmitter() {
  this.events = {};
}

EventEmitter.prototype.on = function (event, listener) {
  if (!this.events[event]) {
    this.events[event] = [];
  }

  this.events[event].push(listener);
};

EventEmitter.prototype.off = function (event, listener) {
  const listeners = this.events[event];

  if (typeof listeners === 'object') {
    const idx = listeners.indexOf(listener);

    if (idx > -1) {
      listeners.splice(idx, 1);
    }
  }
};

EventEmitter.prototype.emit = function (event, ...args) {
  let listeners = this.events[event];

  if (typeof listeners === 'object') {
    listeners = listeners.slice();
    const length = listeners.length;

    for (let i = 0; i < length; i++) {
      listeners[i].apply(this, args);
    }
  }
};

EventEmitter.prototype.once = function (event, listener) {
  this.on(event, function eventCallback(...args) {
    this.off(event, eventCallback);
    listener.apply(this, args);
  });
};

exports.default = EventEmitter;
